// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3ZUCi","content":"GlobalSearch_content__2WZHg"};